import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles redirect-back from Emergent's Google OAuth flow.
 * URL fragment carries `#session_id=...` — we exchange it on the backend
 * for our normal JWT cookie session, then navigate to the dashboard.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // Parse session_id from URL hash fragment
    const hash = (window.location.hash || "").replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const sid = params.get("session_id");
    if (!sid) {
      setError("Sessão Google não encontrada no URL.");
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sid });
        // Clean the URL fragment and refresh auth context
        window.history.replaceState({}, document.title, "/");
        if (refresh) await refresh();
        navigate("/", { replace: true });
      } catch (err) {
        setError(formatApiError(err));
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col items-center justify-center p-6" data-testid="auth-callback-page">
      {error ? (
        <>
          <h1 className="font-display text-3xl font-black uppercase">Login Google falhou</h1>
          <p className="text-[#FCA5A5] mt-3 max-w-md text-center">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })}
            className="kw-btn-primary mt-6" data-testid="auth-callback-back">
            Voltar ao login
          </button>
        </>
      ) : (
        <p className="text-[#A3A3A3]">A concluir o teu login Google…</p>
      )}
    </div>
  );
}
